import { VHeaders } from '@/models/pagedlistmodel';

export function getVehicleReviveStepsHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveSteps.vehicleReviveStepHeaders.step'
      ) as string,
      value: 'step',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveSteps.vehicleReviveStepHeaders.name'
      ) as string,
      value: 'name',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'vehicleReviveSteps.vehicleReviveStepHeaders.description'
      ) as string,
      value: 'description',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'vehicleReviveSteps.vehicleReviveStepHeaders.action'
      ) as string,
      sortable: false,
    },
  ];
}
